/* 10.10.26 (Philipp): Sondergroesse/Sonderhoehe auf der Produktseite 1:1 wie Konfigurator B
   (sections/desk-con-apple-b.liquid, renderSizes + renderCustomUpcharge).
   Die Preisrechnung bleibt in der Section (billingSize/oversizeSteps, dieselbe Regel wie im
   Konfigurator); hier nur Anzeige: Chip-Beschriftung, Werte rechts, Aufpreis-Zeilen.
   Aufruf aus render() der Section: EhMkSg(root, state, steps, oversize, money). */
(function () {
  var CS_T = [60, 70, 80, 90, 100, 108, 110, 120];
  function setze(root, k, v) {
    var el = root.querySelector('[data-mk-val="' + k + '"]');
    if (el) el.textContent = String(v);
  }
  window.EhMkSg = function (root, state, st, ov, money) {
    var c = state.custom;
    var box = root.querySelector('[data-mk-custom]');
    if (box) box.hidden = !c;
    var chip = root.querySelector('[data-mk-size="custom"]');
    if (chip) chip.textContent = c ? 'Sondergröße (' + c.l + '×' + c.d + ' / H ' + c.h + ')' : 'Sondergröße';
    var hChip = root.querySelector('[data-mk-hoehe]');
    if (hChip) hChip.textContent = state.arcH ? 'Sonderhöhe (H ' + state.arcH + ')' : 'Sonderhöhe';
    if (c) { setze(root, 'l', c.l); setze(root, 'd', c.d); setze(root, 'h', c.h); }
    else if (state.arcH) setze(root, 'h', state.arcH);

    var auf = root.querySelector('[data-mk-cs-auf]');
    if (!auf || !(c || state.arcH)) return;
    var pW = st.w * ((ov.w && ov.w.price) || 0);
    var pD = st.d * ((ov.d && ov.d.price) || 0);
    var pH = st.h * ((ov.h && ov.h.price) || 0);
    var zeile = function (t, p, k) {
      return '<div class="eh-mk-cs__' + (k || 'z') + '"><span>' + t + '</span><strong>' + money(p) + '</strong></div>';
    };
    if (pW + pD + pH <= 0) { auf.innerHTML = '<div class="eh-mk-cs__z is-none">Kein Übermaß-Aufpreis</div>'; return; }
    auf.innerHTML =
      (pW > 0 ? zeile('Übergröße - Länge (' + st.w + '×)', pW) : '') +
      (pD > 0 ? zeile('Übergröße - Tiefe (' + st.d + '×)', pD) : '') +
      (pH > 0 ? zeile('Sonderhöhe (einmalig)', pH) : '') +
      zeile('Zusatz gesamt', pW + pD + pH, 'sum');
  };
  window.EhMkSg.CS_T = CS_T;
})();
